module.exports = __webpack_public_path__ + "static/scale-model-of-discovery-forest-in-cincinnati-ohio-1e6bd1afcbe0eef6bd77636f2c9894e4.png";